import { Component, OnInit, ViewChild } from "@angular/core";
import {
  AnalyticsService,
  CertificateListService,
  IProvisionedCertificate,
  NotificationService,
  ProfileService,
  VerificationService,
  NotificationKeys,
  ResponseStatus,
  Services,
  UserTypes,
  fileTypes,
  certificateFace,
  certificateViewerCustomBtns,
  externalImageLinks,
  StorageKeys,
  countries,
  CertificateDocsStatus,
  CertificateStatus,
  ImageTypes,
  CertificateOperations,
  faceApiNModels,
  URLS,
  EventListeners,
  Orientations,
  Units,
  ProcessStepsModalKeys,
  ErrorCodes,
} from "@core";
import { ActivatedRoute, Router } from "@angular/router";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { App } from "@delon/theme";
import jspdf from "jspdf";
import { StorageService } from "src/app/core/services/storage/storage.service";
import { BrowserStorageKeys } from "src/app/core/config/browser-storage-keys.config";
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
  FormBuilder,
} from "@angular/forms";
import { NzUploadFile } from "ng-zorro-antd/upload";
import { Observable, Observer } from "rxjs";
import { API_ResponseStatus, API_Statuses } from "src/app/core/config/api-response.config";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { CanComponentDeactivate } from "src/app/core/guards/exit-confirmation.guard";
import { TranslateService } from "@ngx-translate/core";
import { pageRoutes } from "src/app/core/config/page-routes.config";
import { ExamCountrySetupComponent } from "src/app/shared/helpers/global/exam-country-setup/exam-country-setup.component";

@Component({
  selector: "app-certificates",
  templateUrl: "./certificates.component.html",
  styleUrls: ["./certificates.component.less"],
  standalone: false,
})
export class CertificatesComponent implements OnInit, CanComponentDeactivate {
  triggeredCanExit: boolean = false;

  faceAPI: any;

  noCertAccessModal?: NzModalRef;
  certificateBackImage: Blob = new Blob();
  certificateFrontImage: Blob = new Blob();

  accessedItems: any[] = []; //provisionedItems: any[] = [];
  certificateImages: any[] = [];
  ownerCertificates: any[] = [];
  fileList: NzUploadFile[] = [];
  resultList: NzUploadFile[] = [];
  accessedCertificate: any[] = []; //provisionedCertificate = [];
  onConsentCertificates: any[] = [];
  passportList: NzUploadFile[] = [];
  documentList: NzUploadFile[] = [];
  dateofBirthList: NzUploadFile[] = [];
  tempPassportList: NzUploadFile[] = [];
  awaitingConsentCertificates: any[] = [];

  to: number = 0;
  Year: number = 0;
  total: number = 0;
  lastPage: number = 0;
  pageNumber: number = 1;
  userInformationWindowStep: number = 0;

  src: any;
  cert_obj: any;
  imageDataUrl: any;
  verifiedUser: any;
  accessFormData: any;
  provisionObject: any;
  notifyModal?: NzModalRef;
  certificate_id: any = null;
  user_provisioned_object: any;
  invalidCertificateMessage: any;
  selectedCertificateDetails: any;
  haveScannedCertificate: any = null;

  owner: boolean = false;
  loading: boolean = false;
  otpModal: boolean = false;
  validImage: boolean = true;
  isUserVerified: boolean = false;
  analyzingImage: boolean = false;
  hasShareHistory: boolean = false;
  resultStateWindow: boolean = false;
  isUserCertificate: boolean = false;
  showRequestConsent: boolean = false;
  pictureStateWindow: boolean = false;
  certificateLoading: boolean = false;
  showCertificateLayout: boolean = false;
  showCertificatesModal: boolean = false;
  customerSurveyModal: boolean = false;
  isCertificateSelected: boolean = false;
  scannedCertificateShow: boolean = false;
  accept_result_statement: boolean = false;
  certificateStateVerifier: boolean = false;
  displayCertificateViewer: boolean = false;
  hasProvisionedCertificate: boolean = false;
  userInformationVerification: boolean = false;
  scannedStatementofResult: boolean = false;

  examCountrySetupModal: boolean = false;
  @ViewChild(ExamCountrySetupComponent) examCountrySetup!: ExamCountrySetupComponent;
  
  surveyUrl: SafeResourceUrl;
  surveySubmitted: boolean = false;
  notificationKeys = NotificationKeys;
  externalImageLinks = externalImageLinks;

  certificateID: string = "";
  candidateID: string = "";
  candidate_no: string | null = null;
  certificateImageSide: string = certificateFace.FRONT;

  processStepsModalKeys = ProcessStepsModalKeys;
  userTypes = UserTypes;
  pageRoutes = pageRoutes;
  provisionedObjects = CertificateDocsStatus;
  countries = countries;


  loggedInUser: any;

  otpFormGroup!: FormGroup;
  requestDocumentForm = new FormGroup({
    haveScannedCertificate: new FormControl("", [Validators.required]),
    name: new FormControl("", [Validators.required, Validators.minLength(3)]),
    passport: new FormControl("", [Validators.required]),
    passportSource: new FormControl("", [Validators.required]),
    file: new FormControl("", [Validators.required]),
    fileSource: new FormControl("", [Validators.required]),
  });

  constructor(
    private profileService: ProfileService,
    private certificateService: CertificateListService,
    private verifierService: VerificationService,
    private notify: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private modalService: NzModalService,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private analytics: AnalyticsService,
  ) {
    this.surveyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      URLS.SURVEY_HERO,
    );
    window.addEventListener(EventListeners.MESSAGE, this.handleSurveyMessage, false);
    this.buildOtpForm();
    this.load();
    this.patchUserCountryOnLabel();
    this.checkIfQueryParam();
    this.loadFaceApi();
  }

  async patchUserCountryOnLabel() {
    this.loggedInUser = this.storageService.getLocalStorageItem(StorageKeys.TOKEN);
    const countries = await JSON.parse(localStorage.getItem('countryProfiles')!);
    const userCountry = await countries.find((country: any) => country?.id === this.loggedInUser?.exam_country_profile_id);
    this.userCountry = userCountry;
    this.isNigerianCountry = userCountry?.country_code === 'NG';
  }

  canExit(): boolean {
    if (
      this.surveyShouldBeDisplayed &&
      !this.triggeredCanExit &&
      !this.surveySubmitted
    ) {
      this.customerSurveyModal = true;
      this.triggeredCanExit = true;
      return false;
    }
    return true;
  }

  handleSurveyMessage = (event: MessageEvent) => {
    if (event.origin.includes(URLS?.SURVEY_HERO_LANDING)) {
      if (event.data.type === "response.completed") {
        this.surveySubmitted = true;
        this.surveyDisplayed = true;
      }
    }
  };

  ngOnDestroy() {
    window.removeEventListener(EventListeners.MESSAGE, this.handleSurveyMessage, false);
  }

  ngOnInit(): void {
   
  }

  get user(): App {
    return this.profileService.getLocalStorageUser();
  }

  get f() {
    return this.requestDocumentForm?.controls;
  }

  get otp(): AbstractControl {
    return this.otpFormGroup?.controls.otp;
  }

  config = {
    btnClass: ["default"], // The CSS class(es) that will apply to the buttons
    zoomFactor: 1.5, // The amount that the scale will be increased by
    containerBackgroundColor: "#e4dede", // The color to use for the background. This can provided in hex, or rgb(a).
    primaryColor: "", // Color to use for all buttons image.
    wheelZoom: true, // If true, the mouse wheel can be used to zoom in
    allowFullscreen: true, // If true, the fullscreen button will be shown, allowing the user to enter fullscreen mode
    allowKeyboardNavigation: true, // If true, the left / right arrow keys can be used for navigation
    btnIcons: {
      // The icon classes that will apply to the buttons. By default, font-awesome is used.
      zoomIn: "fa fa-plus",
      zoomOut: "fa fa-minus",
      rotateClockwise: "fa fa-repeat",
      rotateCounterClockwise: "fa fa-undo",
      next: "fa fa-chevron-right",
      prev: "fa fa-chevron-left",
      fullscreen: "fa fa-arrows-alt",
    },
    btnShow: {
      zoomIn: false,
      zoomOut: false,
      rotateClockwise: false,
      rotateCounterClockwise: false,
      next: false,
      prev: false,
    },
    customBtns: [],
  };

  buildOtpForm() {
    this.otpFormGroup = this.fb.group({
      otp: [null, [Validators.required, Validators.minLength(6)]],
    });
  }

  async checkIfQueryParam() {
    const certificateID = this.route?.snapshot?.queryParams;
    if (!certificateID) return;
    this.onSelectCertificate(certificateID?.id);
    this.certificateID = certificateID?.id;
  }

  async userVerificationStatus() {
    this.profileService
      .getUser()
      .then(async (res: any) => {
        const user = await res?.data;
        const provisionedCertificates = await user?.provisioned_candidates;
        const additionalDetail = await user?.additional_detail;

        this.verifiedUser = additionalDetail?.verification_data
          ? additionalDetail.verification_data
          : null;

        this.hasProvisionedCertificate =
          (await provisionedCertificates) == 0 ? false : true;
        if (
          additionalDetail?.identity_verified &&
          provisionedCertificates > 0
        ) {
          this.assignCertificateToCategories();
          this.isUserVerified = await true;
          // Removed duplicate onSelectCertificate call - already handled in checkIfQueryParam()
        }
        this.displayCertificateViewer = true;
      })
      .catch((err: any) => {
        console.warn(err);
      });
  }

  onVerifyIdentity() {
    this.userInformationWindowStep = 2;
    this.userInformationVerification = true;
  }

  userVerificationAfterSuccessViewCertificate() {
    // this.userVerificationStatus();
    this.accessedItems = [];
    this.load();
    this.cancelMeansofIdentificationModal();
  }

  viewCertificate = () => {
    this.router.navigateByUrl(
      `${pageRoutes.certificate.previewCertificate}"${this.certificate_id}?candidate_no=${this.candidate_no}`,
    );
  };

  load() {
    this.loading = true;
    this.certificateService
      .accessedCertificateV2({ page: this.pageNumber, page_size: 60 })
      .then(async (res) => {
        this.loading = false;
        if (res?.status == API_ResponseStatus.FAILED) {
          this.notify.info("", res?.error, this.notificationKeys.CERTIFICATE);
          return;
        }

        this.accessedCertificate = await res?.data?.data;
        this.lastPage = res?.data?.last_page;
        this.total = res?.data?.total;
        this.to = res?.data?.to;
        if (this.accessedItems?.length <= this.total) {
          this.accessedCertificate?.forEach((item: any) => {
            this.accessedItems.push(item);
          });
        }
        this.userVerificationStatus();
      })

      .catch((err) => {
        this.loading = false;
        console.warn(err);
      });
  }

  cancelMeansofIdentificationModal() {
    this.userInformationVerification = false;
  }

  getUserProvisionedObject(id: string) {
    this.certificateService.userProvisionedObject(id).subscribe(
      (res) => {
        if (res.status == ResponseStatus.FAILED) {
          this.notify.error("", res.message, this.notificationKeys.CERTIFICATE);
          return;
        }

        this.owner = res?.data?.owner;
        this.provisionObject = res?.data?.submission_status;
        this.showCertificateLayout = true;

        if (res?.data?.accept_scanned_result == true) {
          this.accept_result_statement = true;
          this.resultStateWindow = true;
        }
      },
      async () => {
        this.loading = false;
      },
    );
  }

  async assignCertificateToCategories() {
    if (!Array.isArray(this.accessedItems)) {
      return;
    }

    this.ownerCertificates = this.accessedItems.filter(
      (certificate: IProvisionedCertificate) =>
        certificate.owner && certificate.status === CertificateStatus.ACTIVE,
    );
    this.onConsentCertificates = this.accessedItems.filter(
      (certificate: IProvisionedCertificate) =>
        certificate.owner == false && certificate.status === CertificateStatus.ACTIVE,
    );
    this.awaitingConsentCertificates = this.accessedItems.filter(
      (certificate: IProvisionedCertificate) =>
        !certificate.owner && certificate.status === CertificateStatus.PENDING,
    );
  }

  checkIfUserHasPermissionToViewCertificate(id: string) {
    this.certificateService.FrontCertificate(id).subscribe(
      (res) => {
        this.loading = false;
        if (res.status == ResponseStatus.FAILED) {
          this.notify.error("", res.message, this.notificationKeys.CERTIFICATE);
        }
        this.router.navigateByUrl(
          `${pageRoutes.certificate.previewCertificate}${id}?candidate_no=${this.candidate_no}`,
        );
      },
      async (err: any) => {
        const text = await err.error?.text();
        const resp: any = JSON.parse(text);
        if (resp.subCode == ErrorCodes.CODE_41) {
          this.router.navigateByUrl(
            `${pageRoutes.certificate.previewCertificate}${id}?candidate_no=${this.candidate_no}`,
          );
        }
        this.notify.error("", resp.message, this.notificationKeys.CERTIFICATE);
        this.loading = false;
      },
    );
  }

  userCountry: any;
  isNigerianCountry = false;

  getCandidateCountry(countryCode: string): string {
    const countries = this.storageService.getLocalStorageItem(
      BrowserStorageKeys.countries,
    );
    const candidateCountry = countries.filter(
      (country: any) => country?.code === countryCode,
    );
    return candidateCountry[0]?.name;
  }

  goToCertificateAccess() {
    this.router.navigate([pageRoutes.access.accessing]);
  }

  hideAngularImageViewerBtns() {
    const configBtnShow = this.config?.btnShow;
    configBtnShow["next"] = false;
    configBtnShow["prev"] = false;
    configBtnShow["rotateClockwise"] = false;
    configBtnShow["rotateCounterClockwise"] = false;
    configBtnShow["zoomIn"] = false;
    configBtnShow["zoomOut"] = false;

    const customBtns: any = [];
    this.config = { ...this.config, customBtns };
  }

  showAngularImageViewerBtns() {
    const configBtnShow: any = this.config?.btnShow;
    configBtnShow["next"] = true;
    configBtnShow["prev"] = true;
    configBtnShow["rotateClockwise"] = true;
    configBtnShow["rotateCounterClockwise"] = true;
    configBtnShow["zoomIn"] = true;
    configBtnShow["zoomOut"] = true;

    const customBtns: any = [
      { name: certificateViewerCustomBtns.LINK, icon: "fa fa-paperclip" },
      { name: certificateViewerCustomBtns.DOWNLOAD, icon: "fa fa-download" },
    ];
    this.config = { ...this.config, customBtns };
  }

  trackDownloads() {
    this.certificateService
      .trackDownloads(this.candidateID)
      .then((res: any) => {
        if (res?.status == API_ResponseStatus.FAILED) {
          console.error(res?.message);
          return;
        }
      })
      .catch((err: any) => {
        console.error(err?.error?.message);
      });
  }

  async checkCertificateOwner(id?: any) {
    const candidateInfo: any = this.accessedItems.filter((c) => c.id === id)[0];

    this.selectedCertificateDetails = await candidateInfo;

    if (this.selectedCertificateDetails?.views < 1) {
      this.surveyShouldBeDisplayed = true;
    }
    this.candidateID = candidateInfo?.candidate?.id;
    this.isUserCertificate =
      candidateInfo?.owner && candidateInfo?.status === CertificateStatus.ACTIVE ? true : false;
  }

  clearQueryParam() {
    const queryParams = this.route.snapshot.queryParams;
    if (!queryParams) return;
    this.router.navigate([pageRoutes.certificates.certificates]);
  }

  async onSelectCertificate(certificateID: any) {
    this.certificateImages = await [];
    this.showCertificateLayout = false;
    this.invalidCertificateMessage = false;
    this.isUserCertificate = false;

    if (!certificateID) {
      this.selectedCertificateDetails = null;
      this.showCertificateLayout = false;
      this.isUserCertificate = false;
      this.hideAngularImageViewerBtns();
      this.clearQueryParam();
      return;
    }

    this.router.navigate([pageRoutes.certificates.certificates], {
      queryParams: { id: certificateID },
    });
    this.certificateLoading = await true;
    this.getPictureState(certificateID);
  }

  async getCertificateFront(id: string) {
    (this.user.type == UserTypes.VERIFIER
      ? this.verifierService
      : this.certificateService
    )
      .FrontCertificate(id)
      .subscribe(
        async (res: any) => {
          if (res.status == ResponseStatus.FAILED) {
            this.certificateLoading = await false;
            this.hideAngularImageViewerBtns();
          }

          this.certificateFrontImage = res;
          this.createImageFromBlob(res);
          this.certificateImageSide = certificateFace.FRONT;
          this.certificateLoading = await true;
          this.getCertificateBack(id);
          this.checkCertificateOwner(id);
          this.showAngularImageViewerBtns();
        },
        async (err: any) => {
          const text = await err.error?.text();
          const resp: any = JSON.parse(text);
          this.notify.error("", resp.message, NotificationKeys.ACCESS);
          this.loading = false;
          this.certificateLoading = false;
          this.hideAngularImageViewerBtns();
        },
      );
  }

  async getCertificateBack(id: string) {
    (this.user.type == UserTypes.VERIFIER
      ? this.verifierService
      : this.certificateService
    )
      .BackCertificate(id)
      .subscribe(
        async (res) => {
          if (res.status == ResponseStatus.FAILED) {
            this.certificateLoading = await false;
            return;
          }
          this.certificateLoading = await false;
          this.certificateBackImage = res;
          this.certificateImageSide = certificateFace.BACK;
          this.createImageFromBlob(res);
        },
        async (err: any) => {
          console.warn(err);
          this.loading = false;
          this.certificateLoading = await false;
        },
      );
  }

  async getPictureState(id: string) {
    (this.user.type == UserTypes.VERIFIER
      ? this.verifierService
      : this.certificateService
    )
      .pictureState(id)
      .subscribe(
        (res: any) => {
          if (res?.status == ResponseStatus.FAILED) {
            this.certificateLoading = false;
            return;
          }

          if (res?.data == false) {
            this.hideAngularImageViewerBtns();
            this.certificateLoading = false;
            this.showCertificateLayout = true;

            if (this.user.type == UserTypes.USER) {
              this.getUserProvisionedObject(id);
            }

            if (this.user.type == UserTypes.VERIFIER) {
              this.certificateStateVerifier = true;
            }
            return;
          }

          this.showCertificateLayout = false;
          this.showRequestConsent = false;
          this.getCertificateFront(id);
        },
        async (err: any) => {
          // this.notify.error("", err?.error?.message, NotificationKeys.ACCESS);
          this.invalidCertificateMessage = err?.error?.message;
          this.certificateLoading = false;
          this.loading = false;

          if (err?.error?.subCode == API_Statuses[602]) {
            this.showRequestConsent = true;
          }
        },
      );
  }

  async addImageProcess(src: any) {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.src = src;
      img.onload = () => resolve(img);
      img.onerror = reject;
    });
  }

  async generatePDF(item: any) {
    const doc = new jspdf({
      orientation: Orientations.PORTRAIT,
      unit: Units.PX,
    });

    for (const [i, img] of item.entries()) {
      const image: any = await this.addImageProcess(img);
      doc.addImage(image, ImageTypes.JPG, 0, 0, 430, 632);
      if (i !== this.certificateImages.length - 1) {
        doc.addPage();
      }
    }
    return doc;
  }

  async downloadCertificate() {
    this.analytics.download(Services.ACCESSING);
    const multiJpg: any = await this.generatePDF(this.certificateImages);
    const firstname = this.selectedCertificateDetails?.candidate?.firstname;
    const othernames = this.selectedCertificateDetails?.candidate?.othernames;
    const surname = this.selectedCertificateDetails?.candidate?.surname;
    const candidateName = `${surname} ${firstname} ${othernames}`;
    this.trackDownloads();
    multiJpg.output(CertificateOperations.SAVE, candidateName);
  }

  async loadFaceApi() {
    if (!this.faceAPI) {
      this.faceAPI = await import("@vladmandic/face-api");
    }
    
    const MODEL_URL = faceApiNModels.SSD_MOBILENET;
    await this.faceAPI.nets.ssdMobilenetv1.loadFromUri(MODEL_URL);
  }

  async detectFace(file: any): Promise<Array<any>> {
    this.analyzingImage = true;
    const image = await this.faceAPI.bufferToImage(file);
    const detections = await this.faceAPI.detectAllFaces(
      image,
      new this.faceAPI.SsdMobilenetv1Options(),
    );
    console.log(detections);
    return detections;
    // const imageScore = detections[0]?.score*100;
    // this.analyzingImage = false;
    // return imageSelected.length === 1 && imageScore > 94;
  }

  handleCertificateEvent(event: any) {
    if (this.user_provisioned_object == false) {
      this.notify.info(
        "",
        this.translate.instant(
          "PREVIEW-CERTIFICATE.VIEW-CERTIFICATE.CERTIFICATE_NOT_AVAILABLE",
        ),
        "",
      );
      return;
    } else {
      switch (event.name) {
        case certificateViewerCustomBtns.LINK:
          break;

        case certificateViewerCustomBtns.DOWNLOAD:
          this.downloadCertificate();
          break;
      }
    }
  }

  surveyDisplayed: boolean = false;
  surveyShouldBeDisplayed: boolean = false;

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener(
      CertificateOperations.LOAD,
      () => {
        this.certificateImages.push(reader.result);
      },
      false,
    );

    if (image) {
      reader.readAsDataURL(image);
    }
    this.certificateLoading = false;

    if (this.surveyShouldBeDisplayed) {
      setTimeout(() => {
        this.customerSurveyModal = true;
        this.surveyDisplayed = true;
      }, 10000);
    }
  }

  flipCertificateView(): void {
    if (this.certificateImageSide == certificateFace.FRONT) {
      this.createImageFromBlob(this.certificateBackImage);
      this.certificateImageSide = certificateFace.BACK;
    } else {
      this.createImageFromBlob(this.certificateFrontImage);
      this.certificateImageSide = certificateFace.FRONT;
    }
  }

  handleModalCancel() {
    this.resultStateWindow = false;
  }

  openCertificatesModal() {
    this.showCertificatesModal = true;
  }

  async closeCertificatesModal(event: any) {
    this.assignCertificateToCategories();
    if (event) {
      this.selectedCertificateDetails = await event;
      this.certificateID = await event?.id;
      this.onSelectCertificate(event?.id);
      this.showCertificatesModal = false;
      return;
    }

    this.showCertificatesModal = false;
  }

  showUploadForm() {
    this.pictureStateWindow = true;
  }

  handleUploadModalCancel() {
    this.pictureStateWindow = false;
    this.resultStateWindow = false;
    this.imageDataUrl = null;

    this.requestDocumentForm.patchValue({
      haveScannedCertificate: null,
    });
    this.scannedCertificateShow = false;
    this.scannedStatementofResult = false;
  }

  prePassportUpload = (file: NzUploadFile): Observable<boolean> =>
    new Observable((observer: Observer<boolean>) => {
      this.imageDataUrl = null;
      const isJpgOrPng =
        file.type === fileTypes.JPG || file.type === fileTypes.PNG;
      if (!isJpgOrPng) {
        this.notify.error(
          "",
          this.translate.instant('ENQUIRY.FILE_FORMAT_ERROR'),
          this.notificationKeys.CERTIFICATE,
        );
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.notify.error(
          "",
          this.translate.instant(
            "PROVISIONING.CERTIFICATES.PASSPORT_SIZE_WARNING",
          ),
          this.notificationKeys.CERTIFICATE,
        );
        observer.complete();
        return;
      }

      this.detectFace(file).then((detections) => {
        this.displayImage(file);

        this.analyzingImage = false;
        // Invalid Detection Conditions
        if (detections?.length === 0) {
          this.validImage = false;
          this.notify.error(
            "",
            this.translate.instant(
              "PREVIEW-CERTIFICATE.VIEW-CERTIFICATE.PLEASE_SELECT_VALID_IMAGE",
            ),
            this.notificationKeys.CERTIFICATE,
          );
          observer.complete();
          return;
        }
        if (detections.length > 1) {
          this.validImage = false;
          this.notify.error(
            "",
            this.translate.instant(
              "PREVIEW-CERTIFICATE.VIEW-CERTIFICATE.FACE_WARNING",
            ),
            this.notificationKeys.CERTIFICATE,
          );
          observer.complete();
          return;
        }
        if (detections[0]?.score * 100 < 94) {
          this.validImage = false;
          this.notify.error(
            "",
            this.translate.instant("PROVISIONING.CERTIFICATES.CLEARER_IMAGE"),
            this.notificationKeys.CERTIFICATE,
          );
          observer.complete();
          return;
        }

        this.validImage = true;
        this.passportList = [];
        this.passportList = this.passportList.concat(file);
        this.src = this.passportList[0];
        observer.complete();
      });
    });

  preDocumentUpload = (file: NzUploadFile): Observable<boolean> =>
    new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng =
        file.type === fileTypes.PDF || file.type === fileTypes.PNG;
      if (!isJpgOrPng) {
        this.notify.error(
          "",
          this.translate.instant(
            "PREVIEW-CERTIFICATE.VIEW-CERTIFICATE.ONLY_PDF_PNG",
          ),
          this.notificationKeys.CERTIFICATE,
        );
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.notify.error(
          "",
          this.translate.instant(
            "PROVISIONING.CERTIFICATES.PASSPORT_SIZE_WARNING",
          ),
          this.notificationKeys.CERTIFICATE,
        );
        observer.complete();
        return;
      }
      this.documentList = [];
      this.documentList = this.documentList.concat(file);
      observer.complete();
    });

  preResultUpload = (file: NzUploadFile): Observable<boolean> =>
    new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng =
        file.type === fileTypes.PDF || file.type === fileTypes.PNG;
      if (!isJpgOrPng) {
        this.notify.error(
          "",
          this.translate.instant(
            "PREVIEW-CERTIFICATE.VIEW-CERTIFICATE.ONLY_PDF_PNG",
          ),
          this.notificationKeys.CERTIFICATE,
        );
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.notify.error(
          "",
          this.translate.instant(
            "PROVISIONING.CERTIFICATES.PASSPORT_SIZE_WARNING",
          ),
          this.notificationKeys.CERTIFICATE,
        );
        observer.complete();
        return;
      }
      //observer.next(isJpgOrPng && isLt2M);
      this.resultList = [];
      this.resultList = this.resultList.concat(file);
      observer.complete();
    });

  preBirthDocumentUpload = (file: NzUploadFile): Observable<boolean> =>
    new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng =
        file.type === fileTypes.JPG || file.type === fileTypes.PNG;
      if (!isJpgOrPng) {
        this.notify.error(
          "",
          this.translate.instant(
            "PREVIEW-CERTIFICATE.VIEW-CERTIFICATE.ONLY_PDF_PNG",
          ),
          this.notificationKeys.CERTIFICATE,
        );
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.notify.error(
          "",
          this.translate.instant(
            "PROVISIONING.CERTIFICATES.PASSPORT_SIZE_WARNING",
          ),
          this.notificationKeys.CERTIFICATE,
        );
        observer.complete();
        return;
      }
      //observer.next(isJpgOrPng && isLt2M);
      this.dateofBirthList = [];
      this.dateofBirthList = this.dateofBirthList.concat(file);
      observer.complete();
    });

  convertToBase64(file: File) {
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  displayImage(file: any) {
    const reader = new FileReader();
    reader.onload = (e) => {
      this.imageDataUrl = e.target?.result;
    };
    reader.readAsDataURL(file);
  }

  checkRequestValidity(): boolean {
    if (this.passportList.length == 0) {
      this.notify.info(
        "",
        this.translate.instant(
          "PREVIEW-CERTIFICATE.VIEW-CERTIFICATE.KINDLY_UPLOAD_PASSPORT",
        ),
        this.notificationKeys.CERTIFICATE,
      );
      this.loading = false;
      return false;
    }

    if (this.dateofBirthList.length == 0) {
      this.notify.info(
        "",
        this.translate.instant(
          "PREVIEW-CERTIFICATE.VIEW-CERTIFICATE.KINDLY_UPLOAD_BIRTH_CERTIFICATE",
        ),
        this.notificationKeys.CERTIFICATE,
      );
      this.loading = false;
      return false;
    }

    if (this.requestDocumentForm.value.haveScannedCertificate == "") {
      this.notify.info(
        "",
        this.translate.instant(
          "PREVIEW-CERTIFICATE.VIEW-CERTIFICATE.KINDLY_RESPOND",
        ),
        this.notificationKeys.CERTIFICATE,
      );
      this.loading = false;
      return false;
    }

    if (
      this.requestDocumentForm.value.haveScannedCertificate == "no" &&
      this.resultList?.length === 0
    ) {
      this.notify.info(
        "",
        this.translate.instant(
          "PROVISIONING.CERTIFICATES.KINDLY_UPLOAD_STATEMENT",
        ),
        this.notificationKeys.CERTIFICATE,
      );
      this.loading = false;
      return false;
    }

    if (
      this.requestDocumentForm.value.haveScannedCertificate == "yes" &&
      this.documentList.length === 0
    ) {
      this.notify.info(
        "",
        this.translate.instant(
          "PREVIEW-CERTIFICATE.VIEW-CERTIFICATE.KINDLY_UPLOAD_SCANNED_CERTIFICATE",
        ),
        this.notificationKeys.CERTIFICATE,
      );
      this.loading = false;
      return false;
    }
    return true;
  }

  submitStatementResult() {
    this.analytics.formSubmitted('statement_of_result', 'valid');
    this.loading = true;
    const formData = new FormData();
    this.resultList.forEach((file: any) => {
      formData.append("resultStatement", file);
    });
    formData.append("userProvisionedCandidateID", this.certificateID);

    this.certificateService.submitResultStatement(formData).subscribe(
      (res) => {
        this.loading = false;
        if (res.status == ResponseStatus.FAILED) {
          this.notify.error("", res.message, this.notificationKeys.CERTIFICATE);
          return;
        }
        this.notify.success("", res.message, this.notificationKeys.CERTIFICATE);
        this.getUserProvisionedObject(this.certificateID);
        this.handleUploadModalCancel();
      },
      async (err: any) => {
        console.warn(err);
        this.loading = false;
      },
    );
  }

  submitDocuments() {
    this.analytics.formSubmitted('certificate_documents', 'valid');
    this.loading = true;
    let proceed = true;
    proceed = this.checkRequestValidity();

    if (!proceed) {
      return;
    } else {
      const formData = new FormData();
      this.passportList.forEach((file: any) => {
        this.src = file;
        formData.append("user_passport", file);
      });

      this.documentList.forEach((file: any) => {
        formData.append("scanned_certificate_url", file);
      });

      this.dateofBirthList.forEach((file: any) => {
        formData.append("scanned_birth_certificate_url", file);
      });

      formData.append(
        "is_scanned_certificate",
        this.requestDocumentForm.value.haveScannedCertificate || "",
      );

      this.resultList.forEach((file: any) => {
        formData.append("resultStatement", file);
      });

      formData.append("userProvisionedCandidateID", this.certificateID);

      this.certificateService.submitInitialDocuments(formData).subscribe(
        (res) => {
          this.loading = false;
          if (res?.status == ResponseStatus.FAILED) {
            this.notify.error(
              "",
              res?.message,
              this.notificationKeys.CERTIFICATE,
            );
            return;
          }

          this.passportList = [];
          this.documentList = [];
          this.resultList = [];
          this.fileList = [];
          this.dateofBirthList = [];

          this.notify.success(
            "",
            res?.message,
            this.notificationKeys.CERTIFICATE,
          );
          this.getUserProvisionedObject(this.certificateID);
          this.handleUploadModalCancel();
        },
        async (err: any) => {
          console.warn(err);
          this.loading = false;
        },
      );
    }
  }

  onIsScannedCopyAvailable(evt: string) {
    this.scannedCertificateShow = false;
    this.scannedStatementofResult = false;
    if (evt == "yes") {
      this.scannedCertificateShow = true;
    }
    if (evt == "no") {
      this.scannedStatementofResult = true;
    }
  }

  onScrolledToBottom() {
    this.pageNumber += 1;
    if (this.accessedItems?.length < this.total) {
      this.load();
    }
  }

  openOtpModal() {
    this.otpModal = true;
  }

  cancelOtpModal(): void {
    this.otpModal = false;
    this.otpFormGroup.reset();
  }

  showNotify(): void {
    this.notifyModal = this.modalService.confirm({
      nzTitle: this.translate.instant(
        "PROVISIONING.CERTIFICATES.REQUEST_CONSENT",
      ),
      nzContent: this.translate.instant(
        "PROVISIONING.CERTIFICATES.PROCEED_CONFIRMATION",
      ),
      nzMaskClosable: false,
      nzOkText: this.translate.instant("GENERAL.YES"),
      nzOnOk: () =>
        setTimeout(() => {
          this.notifiyOwner();
        }, 500),
      nzCancelText: this.translate.instant("GENERAL.NO"),
    });
  }

  notifiyOwner() {
    this.loading = true;
    let body: any = {
      provision_id: this.certificateID,
    };

    this.certificateService
      .notifyUser(body)
      .then((res) => {
        this.loading = false;

        if (res?.status == ResponseStatus.ERROR) {
          this.notify.error("", res?.error, NotificationKeys.ACCESS);
          return;
        }

        this.accessFormData = res?.data;
        this.notify.info("", res?.message, NotificationKeys.ACCESS);
      })
      .catch((err) => {
        this.loading = false;
        console.warn(err);
      });
  }

  submitOtp() {
    this.loading = true;
    this.otp.markAsDirty();
    this.otp.updateValueAndValidity();

    if (this.otp.invalid) {
      this.analytics.formSubmitted('certificate_otp', 'invalid');
      this.loading = false;
      return;
    }
    this.analytics.formSubmitted('certificate_otp', 'valid');

    let body: any = {
      id: this.certificateID,
      otp: this.otp.value,
    };

    this.certificateService
      .validateOtp(body)
      .then((res) => {
        this.loading = false;
        if (res?.status == ResponseStatus.FAILED) {
          this.analytics.otpSendFailed();
          this.notify.info("", res?.message, NotificationKeys.ACCESS);
          return;
        }
        this.analytics.otpVerified();
        this.notify.success("", res?.message, NotificationKeys.ACCESS);
        this.onSelectCertificate(this.certificateID);
        this.showRequestConsent = false;
        this.cancelOtpModal();
      })
      .catch((err) => {
        this.loading = false;
        this.notify.error("", err?.error?.message, NotificationKeys.ACCESS);
      });
  }

  cancelSurveyModal() {
    // this.surveyShouldBeDisplayed = false;
    this.surveyDisplayed = true;
    this.customerSurveyModal = false;
  }

  closeExamCountrySetupModal() {
    this.examCountrySetup?.modalRef?.close();
  }
}